(function () {

  function initSlider(el) {
    if (el._prSliderInited) return;
    el._prSliderInited = true;

    var minR = el.querySelector('.filter__price_min');
    var maxR = el.querySelector('.filter__price_max');
    var minI = el.querySelector('[id$="-GTE"]');
    var maxI = el.querySelector('[id$="-LTE"]');
    var wrap = el.querySelector('.facets-price__range');

    if (!minR || !maxR || !wrap) return;

    var MAX = parseInt(minR.max) || 0;
    if (!MAX) return;

    minR.style.zIndex = '3';
    maxR.style.zIndex = '4';

    minR.addEventListener('pointerdown', function () {
      minR.style.zIndex = '5';
      maxR.style.zIndex = '4';
    });
    maxR.addEventListener('pointerdown', function () {
      maxR.style.zIndex = '5';
      minR.style.zIndex = '4';
    });

    /* CSS változókat a .facets-price__range-re állítjuk — ::after pseudo-elem olvassa */
    function updateFill() {
      var lo = parseInt(minR.value) || 0;
      var hi = parseInt(maxR.value) || MAX;
      wrap.style.setProperty('--fill-left',  (lo / MAX * 100).toFixed(2) + '%');
      wrap.style.setProperty('--fill-right', ((MAX - hi) / MAX * 100).toFixed(2) + '%');
    }

    minR.addEventListener('input', function (e) {
      e.stopPropagation();
      if (minI) minI.value = parseInt(minR.value) || 0;
      updateFill();
    });

    maxR.addEventListener('input', function (e) {
      e.stopPropagation();
      if (maxI) maxI.value = parseInt(maxR.value) || MAX;
      updateFill();
    });

    minR.addEventListener('change', updateFill);
    maxR.addEventListener('change', updateFill);

    updateFill();
  }

  function initAll() {
    document.querySelectorAll('price-range').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  new MutationObserver(function () {
    document.querySelectorAll('price-range').forEach(function (el) {
      if (!el._prSliderInited) initSlider(el);
    });
  }).observe(document.body, { childList: true, subtree: true });

})();